import { CollectionDataCache } from "@/types";

export type PhotoCategories = "avatar" | "cover";

export interface SocialItem {
  name: string;
  link: string;
}

export interface RoyaltyParams {
  numerator: number;
  denominator: number;
  destination: string;
}

export interface WhitelistRefreshData {
  collection: string;
  profiles: string[];
}

export interface OwnerFileItem {
  id: number;
  url: string;
  category: PhotoCategories;
}

export interface HideCollectionRequestData {
  address: string; // owner
  collection: string; // collection address
  hide?: boolean;
}

export interface ReferralStatsExtended {
  referral_percent: number;
  referral_count: number;
  total_turnover: number;
  total_income: number;
  referral_reward: number;
  available: number;
  referral_collection_count?: number;
  referral_item_count?: number;
}

export interface LevelByCount {
  level: number;
  experience: number;
}

export interface ProfileExtendedInfo {
  id: number;
  referral_count?: number;
  display_name: string;
  date_created: Date;
  referral_address: string | null;
  avatar_address: string | null;
  avatar_data_url: string | null;
  avatar_index_in: number | null;
  avatar_saved_at: Date | null;
  background_address: string | null;
  background_data_url: string | null;
  background_index_in: number | null;
  background_saved_at: Date | null;
  referral: ReferralStatsExtended | null;
  experience: LevelByCount | null;
}

export interface ReferralStats {
  referrals: number;
  collections: number;
  total_earned: number;
}

export interface ReferralCustomParams {
  referral_percent: number;
  custom_name?: number;
}

export interface ItemInCollection {
  address: string;
  index: number;
}

export interface IncomeData {
  turnower: number;
  ref_turnower: number;
  comissions: number;
  ref_comissions: number;
}

export interface UserProfileFullData {
  is_deployed: boolean;
  profile_address: string;
  is_whitelisted?: boolean;
  minted_count: number;
  mint_limit?: number;
}

export const defaultIncomeData: IncomeData = {
  turnower: 0,
  ref_turnower: 0,
  comissions: 0,
  ref_comissions: 0,
};

export interface CollectionTrackData {
  address: string;
  category_id: number;
  collection_data: CollectionDataCache;
  item?: {
    address: string;
  };
  items?: {
    address: string;
    index: number;
  }[];
}

export interface WalletListItem {
  wallet: string; // TON address
  profile: string; // TON address
  is_whitelisted: boolean;
}

export interface OwnerRatingRow {
  address: string;
  id: number;
  username: string;
  experience: number;
  stars: number;
  volume: number;
  avatar: string | null;
}
